"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pseudoSelectorMap = {
    // https://github.com/w3c/csswg-drafts/blob/master/selectors-4/Overview.bs
    "&:not()": true,
    "&:is()": true,
    "&:where()": true,
    "&:has()": true,
    "&:dir()": true,
    "&:lang()": true,
    "&:any-link": true,
    "&:link": true,
    "&:visited": true,
    "&:local-link": true,
    "&:target": true,
    "&:target-within": true,
    "&:scope": true,
    "&:current": true,
    "&:current()": true,
    "&:past": true,
    "&:future": true,
    "&:active": true,
    "&:hover": true,
    "&:focus": true,
    "&:focus-within": true,
    "&:focus-visible": true,
    "&:enabled": true,
    "&:disabled": true,
    "&:read-write": true,
    "&:read-only": true,
    "&:placeholder-shown": true,
    "&:default": true,
    "&:checked": true,
    "&:indeterminate": true,
    "&:valid": true,
    "&:invalid": true,
    "&:in-range": true,
    "&:out-of-range": true,
    "&:required": true,
    "&:optional": true,
    "&:blank": true,
    "&:user-invalid": true,
    "&:root": true,
    "&:empty": true,
    "&:nth-child()": true,
    "&:nth-last-child()": true,
    "&:first-child": true,
    "&:last-child": true,
    "&:only-child": true,
    "&:nth-of-type()": true,
    "&:nth-last-of-type()": true,
    "&:first-of-type": true,
    "&:last-of-type": true,
    "&:only-of-type": true,
    "&:nth-col()": true,
    "&:nth-last-col()": true,
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
    "&:defined": true,
    "&:drop": true,
    "&:first": true,
    "&:fullscreen": true,
    "&:host": true,
    "&:host()": true,
    "&:host-context()": true,
    "&:left": true,
    "&:right": true,
    // https://github.com/w3c/csswg-drafts/blob/master/css-pseudo-4/Overview.bs
    "&:after": true,
    "&:before": true,
    "&:first-letter": true,
    "&:first-line": true,
    "&::after": true,
    "&::before": true,
    "&::first-letter": true,
    "&::first-line": true,
    "&::grammar-error": true,
    "&::inactive-selection": true,
    "&::marker": true,
    "&::placeholder": true,
    "&::selection": true,
    "&::spelling-error": true,
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
    "&::backdrop": true,
    "&::cue": true,
    "&::cue-region": true,
    "&::part()": true,
    "&::slotted()": true
};
//# sourceMappingURL=PseudoSelectors.js.map